import React, { useState } from "react";
import { Link } from "react-router-dom";
import Side from "./Side";
import httpService from "../../../services/httpServices/httpServices";
import validationForgetPassword from "../../../validtions/forms/auth/forget-password";
import helperSpinner from "../../../helpers/spinner";

function ForgetPassword() {
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div
        dir="rtl"
        className="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12 pb-2"
      >
        <div className={`${message.type_class}`}>
          <i className={`${message.class_icon} pl-2`}></i>
          <span>{message.text}</span>
        </div>
      </div>
    );
  }

  const sendForm = async (e) => {
    e.preventDefault();
    const email = document.querySelector("#email").value;
    const dataForm = {
      email: email,
    };

    if (validationForgetPassword(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: validationForgetPassword(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const resultMessage = await sendRequest(email);
    setMessage({
      type_class: "alert alert-success m-0",
      text: resultMessage,
      class_icon: "fa fa-exclamation-triangle",
    });
  };

  const sendRequest = async (email) => {
    let result;
    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/auth/forget-password?email=" +
          email
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    return result.data.message;
  };

  return (
    <div
      className="ltr container-fluid container-auth-page "
      id="container-auth-page"
    >
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                <div className="header-box border-radius-auth-page py-1 px-3">
                  بازیابی کلمه عبور
                </div>
                <div className="body-box d-flex flex-column pt-5 pb-2 px-3">
                  <div className="forget-password-box pt-4 border-hilite-2 border-radius-auth-page">
                    <form onSubmit={sendForm}>
                      {messageTag}
                      <div>
                        <div className="d-flex justify-content-center">
                          <input
                            tabIndex="1"
                            dir="rtl"
                            type="email"
                            id="email"
                            required
                            placeholder="ایمیل"
                            className="form-control form-control-hilite w-auto "
                          />
                        </div>

                        <div className="text-center px-3 py-4">
                          <button
                            type="submit"
                            className="btn btn-hilite-1 w-100 border-radius-auth-page"
                          >
                            جستجوی حساب
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="py-1">
                    <span className="pl-2">بازگشت به صفحه</span>
                    <span>
                      <Link to="/login" className="text-link-hilite">
                        ورود
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
